import { Link } from 'react-router-dom';
import type { Crumb } from '@/components/SEO';

// Visual breadcrumb trail. The matching BreadcrumbList JSON-LD is emitted by
// <SEO breadcrumbs={...}> from the same array, so the two cannot disagree.
const Breadcrumbs = ({ items }: { items: Crumb[] }) => (
  <nav aria-label="Breadcrumb" className="text-small">
    <ol className="flex flex-wrap items-center gap-x-2 gap-y-1">
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <li key={c.href} className="flex items-center gap-x-2">
            {i > 0 && (
              <span aria-hidden className="text-forest/50">
                /
              </span>
            )}
            {last ? (
              <span aria-current="page" className="text-forest/70">
                {c.name}
              </span>
            ) : (
              <Link to={c.href} className="underline-offset-[0.3em] hover:underline">
                {c.name}
              </Link>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumbs;
